import { Image, Link, Text } from '@weareconceptstudio/core';

//* Style
import CategoryItemStyle from './style';

const CategoryItem = ({ data }) => {
	return (
		<CategoryItemStyle>
			<Link
				url={`/menu/${data.slug}`}
				className={'link-wrapper'}>
				<Text className={'p1 text-block uppercase'}>{data.name}</Text>

				<Image
					src={data.image.src}
					alt={data.image.alt}
				/>
			</Link>
		</CategoryItemStyle>
	);
};

export default CategoryItem;
